import { render, staticRenderFns } from "./PostLoading.vue?vue&type=template&id=26dab978&scoped=true&"
import script from "./PostLoading.vue?vue&type=script&lang=js&"
export * from "./PostLoading.vue?vue&type=script&lang=js&"
import style0 from "./PostLoading.vue?vue&type=style&index=0&id=26dab978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dab978",
  null
  
)

export default component.exports